import { connect } from "react-redux";
import NavBar from "./navbar";

const mapStateToProps = ({ profile, organisations, jobs, timesheetFormReducer, queue, featureFlags, subscription }) => ({
	role: profile.role,
	currentOrganisationGUID: organisations.currentOrganisation,
	globalMessage: jobs.globalMessage,
	profile: profile,
    timesheetToggle: timesheetFormReducer.timesheet.toggle,
    hasPendingQueue: !!queue.list && queue.list.length > 0,
    hasNetwork: !!queue.hasNetwork,
	featureFlags: featureFlags,
	subscriptionStatus: subscription.subscriptionStatus,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
